import { createFileRoute } from '@tanstack/react-router';
import { LibrarianDashboard } from '@/components/LibrarianDashboard';

export const Route = createFileRoute('/_authenticated/dashboard')({
  component: LibrarianDashboard,
});

